export default "__VITE_ASSET__DLBxysAM__"